   document.addEventListener('DOMContentLoaded', function() {
      const variantSelector = document.querySelector('variant-selection');
      if (variantSelector) {
        variantSelector.addEventListener('change', function(event) {
       const selectedVariantId = variantSelector.getAttribute('variant');
  //     const highup = document.querySelector('highup-inventory');
//highup.setAttribute("data-variant-id", selectedVariantId);
      //   console.log(selectedVariantId);

   // Find the 'highup-inventory' custom element
      const highup = document.querySelector('highup-inventory');

      if (highup) {
        // Update the `data-variant-id` attribute of the 'highup-inventory' element
        highup.setAttribute("data-variant-id", selectedVariantId);

        // Call fetchAvailability to fetch the data for the selected variant
        highup.fetchAvailability(selectedVariantId);
      }

          
        });
      }
    });



if (!customElements.get('highup-inventory')) {
  customElements.define(
    'highup-inventory',
    class highupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
    //    console.log(variantId);
         if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=highup-inventory`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            
          });
      }



  
    



      
      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.custom.location_inventory) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

  

      renderPreview(sectionInnerHTML) {
          if (!sectionInnerHTML.querySelector('highup-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('highup-preview').outerHTML;
        this.setAttribute('available', '');
     }
    }
  );
}

